
import React from 'react';


export default function Header() {
    return (
              <header className="App-header w-full bg-neutral-800 py-4 ">
                <div className="container mx-auto flex items-center justify-between px-2 xlg:px-0">
                  <div className="title text-white text-2xl flex items-center gap-4">
                    <img src="/logo.png" className="App-logo h-10 md:h-16" alt="logo" />
                    <div className="flex flex-col uppercase">
                      <span className="text-sm md:text-xl">
                        <b>Theresianische</b>akademie
                      </span>
                      <span className="text-sm md:text-lg text-neutral-200">
                        <b>Chrono</b>school Web
                      </span>
                    </div>
                  </div>
                  <div className="hidden md:block right">
                    <img src="/dots.svg" alt="dots" className="h-1.5" />
                  </div>
                </div>
              </header>
    )
}